import { useEffect } from 'react';
import { pushCloser, popCloser } from '../utils/backStack';

/**
 * Registers `onClose` while the component is mounted **and** visible.
 * Pass `undefined` or `null` when the UI layer is hidden – it won’t
 * add itself to the stack.
 */
export const useBackClose = (onClose) => {
  useEffect(() => {
    if (!onClose) return;          // closed / not mounted
    pushCloser(onClose);
    return () => popCloser();      // cleanup on unmount
  }, [onClose]);
};
